var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ag-cell",on:{"click":_vm.onClick}},[_c('i',{staticClass:"mdi v-icon",class:{
      'mdi-checkbox-marked': _vm.value,
      'mdi-checkbox-blank-outline': !_vm.value,
    },staticStyle:{"cursor":"pointer"}})])}
var staticRenderFns = []

export { render, staticRenderFns }